import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../services'
import { GetLeaveDetailsPayload, Leave, LeaveMaster } from './type'
import apiEndpoints from '../../const/apiEndpoints'
import history from '../../const/history'

export const applyLeave = createAsyncThunk(
  'manageLeave/applyLeave',
  async (requestPayload: FormData): Promise<Leave> => {
    const headers = {
      'content-type':
        'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW'
    }
    const { data } = await api.post(apiEndpoints.applyLeave, requestPayload, {
      headers
    })

    if (data) {
      history.goBack()
    }

    return data
  }
)

export const getLeaveDetails = createAsyncThunk(
  'session/getLeaveDetails',
  async (): Promise<Array<Leave>> => {
    const { data } = await api.get(apiEndpoints.getLeaveDetails)
    return data
  }
)

export const getLeaveStatusDetails = createAsyncThunk(
  'session/getLeaveStatusDetails',
  async (value: string): Promise<Array<Leave>> => {
    const { data } = await api.get(
      `${apiEndpoints.getLeaveStatus}?value=${value}`
    )
    return data
  }
)

export const getLeaveStatus = createAsyncThunk(
  'session/getLeaveStatus',
  async (value: string): Promise<Leave> => {
    const { data } = await api.get(`${apiEndpoints.getLeaveStatus}?id=${value}`)
    return data
  }
)

export const approveLeave = createAsyncThunk(
  'session/approveLeave',
  async (id: string, { dispatch }): Promise<Leave> => {
    const { data } = await api.get(`${apiEndpoints.approveLeave}${id}`)
    dispatch(getLeaveDetails())
    return data
  }
)

export const rejectLeave = createAsyncThunk(
  'session/rejectLeave',
  async (id: string, { dispatch }): Promise<Leave> => {
    const { data } = await api.get(`${apiEndpoints.rejectLeave}${id}`)
    dispatch(getLeaveDetails())
    return data
  }
)

export const createLeaveMaster = createAsyncThunk(
  'session/createLeaveMaster',
  async (requestPayload: LeaveMaster): Promise<LeaveMaster> => {
    const { data } = await await api.post(
      apiEndpoints.createLeaveMaster,
      requestPayload
    )
    return data
  }
)

export const getLeaveMasterDetails = createAsyncThunk(
  'session/getLeaveMasterDetails',
  async (): Promise<Array<LeaveMaster>> => {
    const { data } = await api.get(apiEndpoints.getLeaveMasterDetails)
    return data
  }
)

export const applyLeaveApi = createAsyncThunk(
  'leave/applyLeave',
  async ({
      leaveType,
      fromDate,
      toDate,
      dayStatus,
      remarks,
      leaveName,
      userId, 
  }: GetLeaveDetailsPayload): Promise<any> => {
      const response = await api.post(
          `${apiEndpoints.applyLeave}?leaveType=${leaveType}&fromDate=${fromDate}&toDate=${toDate}&dayStatus=${dayStatus}&remarks=${remarks}&leaveName=${leaveName}&userId=${userId} `
      )
      return response?.data
  }
)